const peopleEmojis = {
  awkward: '😬',
  bawling: '😭',
  baby: '👶',
  beaming_face_with_smiling_eyes: '😁',
  black_heart_suit: '♥',
  blackheartsuit: '♥',
  blush: '😊',
  boy: '👦',
  card_with_heart: '♥',
  cardwithheart: '♥',
  child: '👶',
  crying: '😭',
  dissatisfied: '😒',
  disappointed_face: '😞',
  distraught_face: '😩',
  distraughtface: '😩',
  drool: '🤤',
  drooling: '🤤',
  drooling_face: '🤤',
  droolingface: '🤤',
  eek: '😬',
  elderly_man: '👴',
  elderlyman: '👴',
  elderly_woman: '👵',
  elderlywoman: '👵',
  expressionless: '😑',
  expressionless_face: '😑',
  eye_roll: '🙄',
  eyeroll: '🙄',
  face_with_head_bandage: '🤕',
  face_with_medical_mask: '😷',
  face_with_rolling_eyes: '🙄',
  facewithrollingeyes: '🙄',
  face_with_tears_of_joy: '😂',
  face_with_thermometer: '🤒',
  face_without_mouth: '😶',
  fearful_face: '😨',
  female: '👩',
  flirt: '😏',
  flirting: '😏',
  foot_in_mouth: '😬',
  footinmouth: '😬',
  grandpa: '👴',
  grandma: '👵',
  girl: '👧',
  grin: '😁',
  grinning: '😀',
  grinning_face: '😀',
  grinning_face_with_big_eyes: '😃',
  grinning_face_with_smiling_eyes: '😁',
  grinning_squinting_face: '😆',
  grimace: '😬',
  grimacing: '😬',
  grimacing_face: '😬',
  grimacingface: '😬',
  heart: '❤️',
  heart_eyes: '😍',
  heart_suit: '♥',
  hearts: '♥',
  heartsuit: '♥',
  heavy_black_heart: '❤️',
  heavyblackheart: '❤️',
  hugging_face: '🤗',
  hushed_face: '😯',
  joy: '😂',
  kissing: '😗',
  kissing_closed_eyes: '😚',
  kissing_heart: '😘',
  kissing_smiling_eyes: '😙',
  lady: '👩',
  laughing: '😆',
  loudly_crying_face: '😭',
  loudlycryingface: '😭',
  love_heart: '❤️',
  loveheart: '❤️',
  man: '👨',
  nanna: '👵',
  nervous: '😬',
  neutral_face: '😐',
  no_mouth: '😶',
  old_lady: '👵',
  oldlady: '👵',
  old_man: '👴',
  oldman: '👴',
  older_man: '👴',
  olderman: '👴',
  old_woman: '👵',
  oldwoman: '👵',
  older_woman: '👵',
  olderwoman: '👵',
  ok: '👌',
  ok_hand: '👌',
  okhand: '👌',
  ok_hand_sign: '👌',
  okhandsign: '👌',
  okay: '👌',
  pensive: '😔',
  pensive_face: '😔',
  pensiveface: '😔',
  perfect: '👌',
  person_shrugging: '🤷',
  personshrugging: '🤷',
  poop: '💩',
  red_heart: '❤️',
  redheart: '❤️',
  relaxed: '☺️',
  relieved_face: '😌',
  rofl: '🤣',
  rolling_on_the_floor_laughing: '🤣',
  rollingonthefloorlaughing: '🤣',
  sad: '😔',
  sad_tears: '😭',
  sadtears: '😭',
  sadface: '😔',
  satisfied: '😆',
  sarcasm: '🙃',
  sexual_face: '😏',
  sexualface: '😏',
  sob: '😭',
  sobbing: '😭',
  shrug: '🤷',
  shrugging: '🤷',
  side_eye: '😒',
  sideeye: '😒',
  silly: '🙃',
  sleeping: '😴',
  sleeping_face: '😴',
  sleepingface: '😴',
  sleepy_face: '😴',
  sleepyface: '😴',
  slightly_smiling_face: '🙂',
  smile: '😄',
  smiley: '😃',
  smiling_face_with_smiling_eyes: '😊',
  smirk: '😏',
  smirk_cat: '😼',
  smirkcat: '😼',
  smirking: '😏',
  smirking_cat: '😼',
  smirking_face: '😏',
  smirkingcat: '😼',
  smirkingface: '😏',
  smug: '😏',
  smug_face: '😏',
  smugface: '😏',
  snorning: '😴',
  sorrowful: '😔',
  sunglasses: '😎',
  suggestive_smile: '😏',
  suggestivesmile: '😏',
  sweat_smile: '😅',
  thinking_face: '🤔',
  thumbs_down: '👎',
  thumbsdown: '👎',
  thumbs_up: '👍',
  thumbsup: '👍',
  toddler: '👶',
  unamused: '😒',
  unamused_face: '😒',
  unamusedface: '😒',
  unimpressed: '😒',
  upside_down_face: '🙃',
  upsidedownface: '🙃',
  wailing: '😩',
  weary: '😩',
  weary_face: '😩',
  wearyface: '😩',
  wink: '😉',
  winking_face: '😉',
  woman: '👩',
  woman_shrugging: '🤷',
  yellow_woman: '👩',
  yellowwoman: '👩',
  yum: '😋',
  zipper_mouth_face: '🤐',
  zzz_face: '😴',
  zzzface: '😴'
}

module.exports = peopleEmojis
